import { render, staticRenderFns } from "./addNewBLRecord.vue?vue&type=template&id=7b121678&"
import script from "./addNewBLRecord.vue?vue&type=script&lang=js&"
export * from "./addNewBLRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports